import { formFieldPropsType, } from "../../lib/formControlFactory";
import { outerLayoutMixinPropsType, } from "../../mixins/outerLayout";
export const textAreaPropsType = formFieldPropsType
    .extend(outerLayoutMixinPropsType)
    .complete({
    autoFocus: true,
    className: true,
    onBlur: true,
    placeholder: true,
    autoExpand: true,
    maxLengthInformationThreshold: true,
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvY29tcG9uZW50cy9UZXh0QXJlYS90eXBlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFQSxPQUFPLEVBRUwsa0JBQWtCLEdBQ25CLE1BQU0sOEJBQThCLENBQUM7QUFDdEMsT0FBTyxFQUVMLHlCQUF5QixHQUMxQixNQUFNLDBCQUEwQixDQUFDO0FBbUJsQyxNQUFNLENBQUMsTUFBTSxpQkFBaUIsR0FBRyxrQkFBa0I7S0FDaEQsTUFBTSxDQUFDLHlCQUF5QixDQUFDO0tBQ2pDLFFBQVEsQ0FBZ0I7SUFDdkIsU0FBUyxFQUFFLElBQUk7SUFDZixTQUFTLEVBQUUsSUFBSTtJQUNmLE1BQU0sRUFBRSxJQUFJO0lBQ1osV0FBVyxFQUFFLElBQUk7SUFDakIsVUFBVSxFQUFFLElBQUk7SUFDaEIsNkJBQTZCLEVBQUUsSUFBSTtDQUNwQyxDQUFDLENBQUMifQ==